import React from 'react';
import styled from '@emotion/styled';
import IdntyHeaderImage from '../../../../shared/images/idnty-registration.png';
import TeamBuildrLogo from '../../../../shared/images/full-logo-white-orange.png';

const IdntyTopContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const IdntyHeaderImageContainer = styled('div')`
  width: 274px;
  aspect-ratio: 261/64;
  background: url(${IdntyHeaderImage}) transparent 0px 0px / 100% 100% no-repeat;
  height: auto;
`;

const IdntySubheaderContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const PoweredByText = styled('div')`
  display: flex;
  width: auto;
  height: 36px;
  flex-direction: column;
  justify-content: center;
  color: #FFF;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; /* 257.143% */
  letter-spacing: 3px;
  text-transform: uppercase;
`;

const TeamBuildrLogoContainer = styled('div')`
  display: flex;
  width: 134.031px;
  height: 22.795px;
  aspect-ratio: 147/25;
  background: url(${TeamBuildrLogo}) transparent 50% / cover no-repeat;
  flex-direction: column;
  justify-content: center;
  color: #FFF;
  text-align: center;
`;

const IdntyRegistrationHeader = () => (
  <IdntyTopContainer>
    <IdntyHeaderImageContainer />
    <IdntySubheaderContainer>
      <PoweredByText>Powered by</PoweredByText>
      <TeamBuildrLogoContainer />
    </IdntySubheaderContainer>
  </IdntyTopContainer>
);

export default IdntyRegistrationHeader;
